import * as React from "react";
const SvgFiBrandsAudition = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-audition_svg__a)">
      <path d="m8.024 8.152 1.38 4.294h-2.76z" />
      <path d="M20.575.43H4.425C1.981.43 0 2.33 0 4.676v14.645c0 2.347 1.981 4.25 4.425 4.25h16.149c2.444 0 4.425-1.903 4.425-4.25V4.677C25 2.331 23.019.43 20.575.43M13.02 16.705h-2.147a.15.15 0 0 1-.165-.11l-.842-2.46H6.049l-.776 2.427a.194.194 0 0 1-.198.143H3.143q-.166 0-.116-.174l3.304-9.015a6 6 0 0 0 .1-.325q.063-.319.065-.642a.1.1 0 0 1 .086-.11h2.656q.115 0 .132.078l3.75 10.03q.048.158-.1.158m7.879-.012-1.701.021a.2.2 0 0 1-.198-.11 2 2 0 0 1-.057-.247 1.4 1.4 0 0 1-.025-.246 2.9 2.9 0 0 1-1.092.665 4.6 4.6 0 0 1-1.14.151c-.398 0-.793-.06-1.171-.179a2.1 2.1 0 0 1-.884-.482 3 3 0 0 1-.578-1.05 4.2 4.2 0 0 1-.206-1.404V9.135a.114.114 0 0 1 .099-.127h1.976a.117.117 0 0 1 .131.096v4.455c-.022.363.084.723.298 1.023.27.297.664.465 1.074.458.266-.025.525-.094.767-.204q.315-.12.578-.325v-5.39q0-.112.149-.112l1.94.005a.1.1 0 0 1 .115.083v.027l-.04 5.81q0 .396.008.706t.033.54l.042.387q.014.127-.118.127" />
    </g>
    <defs>
      <clipPath id="fi-brands-audition_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAudition;
